import holidayService from '../../../common/service/holidayService';
import { getVerIdentifierBodyForDetails } from '../../../common/utils/helperUtils';

const GET_SECTIONS_URL = '/section/fetch';
const GET_USER_PACKAGES_URL = '/personalization/userPackages/fetch';

export const getListingSections = async params => {
  const response = await holidayService.post(
    GET_SECTIONS_URL,
    getVerIdentifierBodyForDetails(params)
  );

  return response;
};

export const getUserPackages = async params => {
  const response = await holidayService.post(GET_USER_PACKAGES_URL, params);

  return response;
};
